import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'titleCase',
  standalone:true
})
export class TitleCasePipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
       if (value === null || value === undefined) {
      return '';
    }
    const str = String(value);
    
    if (!str.trim()) {
      return '';
    }
    
    return str
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
